import styled, { keyframes } from 'styled-components';
import { loading } from '../../theme/animations';
import { Icon } from '../Icon';

const spin = keyframes`
    100% {
        transform: rotate(360deg);
    }
`;

export const CircularProgressBarWrapper = styled.div<{
    withBackground: boolean;
    isSmall: boolean;
    isLight?: boolean;
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    --circle-color: transparent;
    --path-color: props.theme.root.colors.basicColors.white [ '50%'];
    --circle-stroke-opacity: 0.2;
    --circle-stroke-color: white;

    ${props =>
        props.withBackground
            ? ` width: 48px;
                height: 48px;
                background: ${props.theme.root.colors.basicColors.black['50%']}`
            : `
                width: ${props.isSmall ? 24 : 32}px;
                height: ${props.isSmall ? 24 : 32}px;
            `};
    border-radius: 24px;

    .CircularProgressbar {
        width: ${props => (props.isSmall ? 24 : 32)}px;
        height: ${props => (props.isSmall ? 24 : 32)}px;
        animation-name: ${spin};
        animation-duration: 2s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }

    .CircularProgressbar-trail {
        stroke: ${props =>
            props.isLight
                ? 'rgba(255, 255, 255, 0.2)'
                : props.withBackground
                ? 'transparent'
                : props.theme.root.colors.basicColors['30%']};
    }

    .CircularProgressbar-path {
        stroke: ${props =>
            props.isLight
                ? props.theme.root.colors.basicColors.white['50%']
                : props.withBackground
                ? 'white'
                : props.theme.root.colors.basicColors['55%']};
        stroke-width: 6px;
    }
`;

export const CircularProgressBarButton = styled.div<{ isSmall: boolean }>`
    cursor: pointer;
    position: absolute;
    left: calc(50% - ${props => (props.isSmall ? 4 : 8)}px);
    top: calc(50% - ${props => (props.isSmall ? 4 : 8)}px);
`;

export const CircularProgressBarLoader = styled(Icon)`
    ${loading}
`;
